import type { ReactNode } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Stack } from "@similarweb/ui-components/foundations";

type SettingsSectionBlockProps = {
    children: ReactNode;
    dataAutomation?: string;
    padding?: string;
};

export const SettingsSectionBlock = ({
    children,
    dataAutomation,
    padding = "24px 28px",
}: SettingsSectionBlockProps) => {
    return (
        <Stack
            data-automation={dataAutomation}
            width="100%"
            gap="32px"
            border={`1px solid ${colorsPalettes.carbon["50"]}`}
            background={colorsPalettes.carbon["0"]}
            borderRadius="6px"
            padding={padding}
            margin="0 0 20px"
        >
            {children}
        </Stack>
    );
};
